import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

// Connects to data-controller="transaction-form"
export default class extends Controller {
  static targets = [
    "clientSelect",
    "propertySelect",
    "bankAccountSelect",
    "subCostCenterSelect",
    "submitSpinner",
    "kindSelect",
    "amountInput",
  ]

  connect() {
    // Only auto-populate selects if property/bank account are empty AND disabled
    // This prevents overwriting pre-populated values when editing or after validation errors
    const shouldAutoPopulate = this.clientSelectTarget.value &&
                               this.propertySelectTarget.disabled &&
                               this.propertySelectTarget.options.length === 0

    if (shouldAutoPopulate) {
      this.selectClient()
    }

    this.updateAmountKindClass()
  }

  async selectClient(event) {
    const clientId = this.clientSelectTarget.value
    if (!clientId) {
      this.disableClientSelects()
      this.resetCostCenters()
      return
    }
    const url = `/clients/${clientId}/relatives?property_select=${this.propertySelectTarget.id}&bank_account_select=${this.bankAccountSelectTarget.id}&cost_center_select=${this.subCostCenterSelectTarget.id}`
    await get(url, {
      responseKind: "turbo-stream"
    })
    this.enableClientSelects()
  }

  async selectProperty() {
    const propertyId = this.propertySelectTarget.value

    if (!propertyId) {
      this.resetCostCenters()
      return
    }

    const selectedCostCenterId = this.subCostCenterSelectTarget.value
    const url = `/properties/${propertyId}/cost_centers?cost_center_select=${this.subCostCenterSelectTarget.id}&selected_cost_center_id=${selectedCostCenterId}`
    await get(url, {
      responseKind: "turbo-stream"
    })
  }

  disableClientSelects() {
    this.propertySelectTarget.options.length = 0
    this.bankAccountSelectTarget.options.length = 0
    this.propertySelectTarget.disabled = true
    this.bankAccountSelectTarget.disabled = true
  }

  resetCostCenters() {
    this.subCostCenterSelectTarget.value = ''

    const optionGroups = this.subCostCenterSelectTarget.querySelectorAll('optgroup')
    optionGroups.forEach((group) => group.remove())

    const blankOption = this.subCostCenterSelectTarget.querySelector('option[value=""]')
    if (blankOption) {
      blankOption.selected = true
    }

    this.subCostCenterSelectTarget.dispatchEvent(new Event('change', { bubbles: true }))
  }

  enableClientSelects() {
    this.propertySelectTarget.disabled = false
    this.bankAccountSelectTarget.disabled = false
  }

  updateAmountKindClass() {
    if (!this.hasKindSelectTarget || !this.hasAmountInputTarget) return

    this.amountInputTarget.classList.remove("text-error", "text-success")

    if (this.kindSelectTarget.value === "debit") {
      this.amountInputTarget.classList.add("text-error")
    }

    if (this.kindSelectTarget.value === "credit") {
      this.amountInputTarget.classList.add("text-success")
    }
  }

  submitStart(event) {
    this.submitSpinnerTarget.classList.remove("d-none")
  }

  submitEnd(event) {
    this.submitSpinnerTarget.classList.add("d-none")    
  }
}
